import React from 'react'; 
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, ...rest }) => {
	return  (
            <Route 
                {...rest} 
                render={internalProps => rest.canActivate ?
                    <Component {...internalProps}/> : 
                    <Redirect to="/login"/>}/>
    );
};

PrivateRoute.propTypes = {
    component: PropTypes.func.isRequired
};

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/components/autenticacao/PrivateRoute.js